import { serviceName } from '../resources/serviceConstants';
import {
  appendServiceNameToURL,
  appendServicePortToURL,
} from '../resources/serviceURLs';

export const buildProjectAllocationApiUrl = (path) => {
  const serviceURL = appendServiceNameToURL(serviceName.PROJECT_MS);
  const servicePort = appendServicePortToURL(serviceName.PROJECT_MS);
  const baseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

  if (process.env.NODE_ENV === 'production') {
    return `${baseUrl}${serviceURL}/api${path}`;
  }
  return `${baseUrl}:${servicePort}${serviceURL}/api${path}`;
};
